<template>
  <div class="w-100 px-4">
    <div class="w-100">
      <h1>{{firstData(dataList).titleH1}}</h1>
      <h2 class="text-center">{{firstData(dataList).titleH2}}</h2>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    props: {
      dataList: {
        type: Array
      }
    },
    methods: {
      firstData(list) {
        return _.first(list, (item, key) => {
          return (item.delete == false);
        });
      }

    }
  };

</script>
